/** 官网正式域名（二维码等对外链接使用） */
export const siteOrigin = 'http://app.ailengfeng.com.cn'

export const companyInfo = {
  name: '武汉冷丰心格文化科技有限公司',
  shortName: '冷丰',
  slogan: '连接社区门店与居民日常消费',
  description:
    '武汉冷丰心格文化科技有限公司聚焦社区零售数字化场景，围绕即时零售、私域直播、门店履约和用户服务，为社区居民提供便捷、优质、实惠的线上购物体验。',
  secondaryDescription:
    '公司通过整合供应链资源与社区门店服务能力，连接商品、门店、店长与消费者，持续完善线上线下一体化的社区消费场景。',
  email: 'technology@lengfenghl.com.cn',
  phone: '19537259616',
  icp: '鄂ICP备2026009235号-1',
  icpUrl: 'https://beian.miit.gov.cn/',
  copyright: '版权所有 © 2026 武汉冷丰心格文化科技有限公司。保留所有权利。'
}
